module.exports = __webpack_public_path__ + "static/img/day6.2485bad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/day6.jpg
// module id = uB5R
// module chunks = 0